import React from "react";

import { TailwindModal } from "../components";
import { useStore } from "../helpers";
import { observer } from "mobx-react-lite";

import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useTranslation } from "react-i18next";

export const PerformingFaceMatch = observer(() => {
  const { aiGentoolStore } = useStore();
  const { image_match_modal } = aiGentoolStore;
  const {t} = useTranslation("fetchFromFacialRecognition")
  
  return (
    <TailwindModal isOpen={image_match_modal}>
      <div className="bg-common-white rounded-2xl p-4 max-w-4xl w-full mx-auto h-[85vh] flex flex-col items-center justify-center">
        <DotLottieReact
          src="https://lottie.host/b141a335-7115-4ac3-a98f-c644fa6804c4/jJCM507biV.lottie"
          loop
          autoplay
          className={"opacity-75"}
        />

        <p className="text-gray-800 text-base font-medium text-center mt-6">
          {t("image_captured")} <br />
          {t("performing_face_match")}
        </p>
      </div>
    </TailwindModal>
  );
});
